import coreUtils from 'common/src/lib/analytics';
import { scrollToJobForm } from 'common/src/site';
import 'jquery-ui/ui/widgets/autocomplete';

window.coreUtils = coreUtils;

const showConfirmationModal = () => $('#confirmation-modal').modal('show');
const hideConfirmationModal = () => $('#confirmation-modal').modal('hide');

const showPostCodeModal = () => $('#postcode-modal').modal('show');
const hidePostcodeModal = () => $('#postcode-modal').modal('hide');

const parsePostcodeFromLocation = function (locationName) {
  const match = (locationName || '').match(/(\d{4})$/);
  return match ? match[1] : null;
};

const parseSuburbFromLocation = function (locationName) {
  if (!locationName) return null;

  const withoutPostcode = locationName.replace(/\s*,\s*\d{4}\s*$/, '').trim();
  return withoutPostcode.split(',')[0].trim() || null;
};

const parseLocationValue = function (locationValue) {
  const value = (locationValue || '').trim();
  if (!value) return null;

  const parts = value.split(',').map(part => part.trim()).filter(Boolean);
  if (!parts.length) return null;

  const suburb = parts[0];
  const postcodePart = parts[parts.length - 1] || '';
  const postcode = /^\d{4}$/.test(postcodePart)
    ? postcodePart
    : parsePostcodeFromLocation(value);

  return {
    suburb: suburb || null,
    postcode: postcode || null
  };
};

// Example: /url?postcode=2130 -> Open AI Concierge Agent if valid postcode
window.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  const hasPostcode = urlParams.has('postcode');

  if (hasPostcode) {
    const postcode = urlParams.get('postcode');

    if (!window.aiConciergeEnabled) {
      return;
    }

    if (!/^\d{4}$/.test((postcode || '').trim())) {
      return;
    }

    showPostCodeModal();
    document.getElementById('postcode').value = postcode;
    $('#postcode').autocomplete('search', postcode);
  }
});


const getQuotesBtns = document.querySelectorAll('.get-quotes-btn');

getQuotesBtns.forEach((btn) => {
  btn.addEventListener('click', function () {
    showPostCodeModal();

    window.coreUtils.googleAnalytics({
      hitType: 'event',
      eventCategory: 'ai-concierge',
      eventAction: 'launch-postcode-modal'
    });
  });
});

// In‑chat mini‑form
const FormExtension = {
  name: 'Forms',
  type: 'response',
  match: ({trace}) =>
    trace.type === 'Custom_Form' || trace.payload && trace.payload.name === 'Custom_Form',

  render: ({element}) => {
    const formEl = document.createElement('form');

    formEl.innerHTML = `
      <style>
        label{font:1em/1 ;color:#888}
        input[type=text],input[type=email],input[type=tel]{
          width:100%;margin:5px 0;padding:8px 0;background:transparent;
          border:none;border-bottom:.5px solid rgba(0,0,0,.1);outline:0;
        }
        .phone{width:150px}
        @media(max-width:480px){
          input[type=text],input[type=email],input[type=tel]{
            font-size:16px!important;line-height:1.3;
          }
        }
        .invalid{border-color:red}
        .submit{
          display:inline-block;width:100%;padding:.8rem;border:none;
          background:#8DD9BF;color:#000;font:1em/1;border-radius:5px;
          cursor:pointer;text-align:center;
        }
        .submit:hover{background:#7CCFB2;transform:scale(1.02);transition:.2s}
      </style>

      <label>Your name</label>
      <input type="text"  class="name"   required><br><br>

      <label>Your email</label>
      <input type="email" class="email"  required
             pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$"><br><br>

      <label>Mobile number</label>
      <input type="tel"   class="phone"  required pattern="\\d+"><br><br>

      <input type="submit" class="submit" value="Send my details">
    `;

    /* live validation */
    formEl.addEventListener('input', () =>
      ['name', 'email', 'phone'].forEach(c => {
        const i = formEl.querySelector('.' + c);
        if (i.checkValidity()) i.classList.remove('invalid');
      }));

    formEl.addEventListener('submit', e => {
      e.preventDefault();
      const pick = cls => formEl.querySelector(cls);
      const [name, email, phone] =
        ['.name', '.email', '.phone'].map(pick);

      if (![name, email, phone].every(i => i.checkValidity())) {
        [name, email, phone].forEach(i => i.classList.add('invalid'));
        return;
      }

      formEl.querySelector('.submit').remove();
      window.voiceflow.chat.interact({
        type: 'complete',
        payload: {
          name: name.value, email: email.value,
          phone: phone.value
        }
      });

      window.coreUtils.googleAnalytics({ hitType: 'event', eventCategory: 'ai-concierge', eventAction: 'submit-job-posting' })
    });

    element.appendChild(formEl);
  }
};

// Trigger Close Icon > Yes Button
document.getElementById('cancel-chatbot-btn').addEventListener('click', (e) => {
  const backdrop = document.querySelector('#vf-modal-backdrop');
  const postcodeValue = document.querySelector('#hidden-postcode').value;

  hideConfirmationModal();

  if (backdrop) {
    backdrop.remove();
  }

  scrollToJobForm();

  window.coreUtils.googleAnalytics({ hitType: 'event', eventCategory: 'ai-concierge', eventAction: 'cancel-concierge-agent', eventLabel: postcodeValue })
});

// Trigger Close Icon > No Button
document.getElementById('continue-chatbot-btn').addEventListener('click', (e) => {
  hideConfirmationModal();

  document.querySelectorAll('#vf-modal, #vf-modal-backdrop').forEach(el => {
    el.classList.remove('invisible');
  });

  window.coreUtils.googleAnalytics({ hitType: 'event', eventCategory: 'ai-concierge', eventAction: 'continue-concierge-agent' })
});

/* ───────────────────────────────
“GET QUOTES” CLICK HANDLER
─────────────────────────────── */
const postcodeInput = document.getElementById('postcode');
const chatbotLink = document.getElementById('chatbot-link');
let selectedLocation = null;

const getSelectedLocationPostcode = function () {
  if (!selectedLocation) return null;
  return parsePostcodeFromLocation(selectedLocation.name);
};

const getSelectedLocationSuburb = function () {
  if (!selectedLocation) return null;
  return parseSuburbFromLocation(selectedLocation.name);
};

const updatePostcodeSubmitState = function () {
  const selectedPostcode = getSelectedLocationPostcode();
  const selectedSuburb = getSelectedLocationSuburb();
  const hasValidLocation = !!selectedPostcode && !!selectedSuburb;

  chatbotLink.disabled = !hasValidLocation;
};

const resolveLaunchLocation = function () {
  return {
    postcode: getSelectedLocationPostcode(),
    suburb: getSelectedLocationSuburb()
  };
};

$('#postcode').autocomplete({
  appendTo: '#postcode-modal .modal-content',
  source: function (request, response) {
    $.getJSON('/suburbs', { query: request.term, format: 'json' }, function (data) {
      response(data.map(function (item) {
        return {
          label: item.name,
          value: item.name,
          id: item.id,
          name: item.name
        };
      }));
    });
  },
  minLength: 3,
  open: function () {
    $('.ui-autocomplete').css('z-index', 1060);
  },
  select: function (_event, ui) {
    selectedLocation = {
      id: ui.item.id,
      name: ui.item.name || ui.item.value
    };

    postcodeInput.value = ui.item.value;
    updatePostcodeSubmitState();

    return false;
  }
});

// Pressing the Enter key should submit the postcode in the form
postcodeInput.addEventListener('keydown', function (e) {
  if (e.key === 'Enter') {
    e.preventDefault();

    if (!chatbotLink.disabled) {
      chatbotLink.click();
    }
  }
});

postcodeInput.addEventListener('input', function () {
  const value = postcodeInput.value.trim();

  if (selectedLocation && value !== selectedLocation.name) {
    selectedLocation = null;
  }

  updatePostcodeSubmitState();
});

// Trigger Submit Postcode
chatbotLink.addEventListener('click', (e) => {
  e.preventDefault();

  const inputValue = postcodeInput.value.trim();
  const location = resolveLaunchLocation();
  const postcode = location.postcode;
  const suburb = location.suburb;

  hidePostcodeModal();

  document.querySelector('#hidden-postcode').value = postcode || '';

  if (!postcode || !suburb) {
    if (window.location.pathname === '/') {
      scrollToJobForm();
    } else {
      window.location.href = '/?get_quotes=true';
    }

    window.triggerAutocomplete(inputValue);

    return;
  }

  /* inject VF script + load widget once */
  let params = '?';

  if (postcode) params += '&postcode=' + encodeURIComponent(postcode);
  if (suburb) params += '&suburb_name=' + encodeURIComponent(suburb);
  params += '&job=' + encodeURIComponent(window.aiConciergeJob || 'painting');
  params += '&redirect_base=';
  params += '&ref=' + encodeURIComponent(window.location.origin);

  params = params.replace('?&', '?');

  ;(function (d) {
    var iframe = document.createElement("iframe")

    iframe.id = "ss-wizard"
    iframe.src =
      "https://langgraph-backend-production.up.railway.app/static/embed-wizard.html" +
      params

    iframe.style.position = "fixed"
    iframe.style.top = "0"
    iframe.style.left = "0"
    iframe.style.width = "100%"
    iframe.style.height = "100vh"
    iframe.style.border = "none"
    iframe.style.zIndex = "9999"

    iframe.allow = "camera"

    document.body.appendChild(iframe)

    function handleConciergeClosed() {
      // Clean up iframe after concierge is closed
      var iframe = document.getElementById("ss-wizard")
      if (iframe) {
        iframe.remove()
      }
    }

    if (!window.__aiConciergeListenerRegistered) {
      window.addEventListener("message", function (event) {
        var data = event.data

        if (data && data.type === "AI_CONCIERGE_CLOSED") {
          handleConciergeClosed()
        }
      })

      window.__aiConciergeListenerRegistered = true
    }
    // })(document)

    // v.src =
    //   "https://cdn.voiceflow.com/widget-next/bundle.mjs?v=1.04&t=" + Date.now()
    // v.type = "text/javascript"
    // s.parentNode.insertBefore(v, s)
  })(document, "script");

  window.coreUtils.googleAnalytics({ hitType: 'event', eventCategory: 'ai-concierge', eventAction: 'launch-concierge-agent', eventLabel: postcode })
});
